import GiftInfoRow from '@activities/gift/_shared/components/GiftInfoRow';
import styled from '@emotion/styled';
import { GiftBoxResponse } from '@models/gift';

import useGiftInfoRows from './hooks/useGiftInfoRows';

interface Props {
    giftBox: GiftBoxResponse;
}

function GiftInfo({ giftBox }: Props) {
    const rows = useGiftInfoRows(giftBox);

    return (
        <List>
            {rows.map((row) => (
                <GiftInfoRow key={row.label} label={row.label} spacing={4} align='flex-start'>
                    {row.value}
                </GiftInfoRow>
            ))}
        </List>
    );
}

const List = styled.dl`
    display: flex;
    width: 100%;
    margin: 0;
    flex-direction: column;
    gap: var(--spacing-2);
    padding: var(--spacing-1) 0;
`;

export default GiftInfo;
